import {
  isGeografi,
  isValgResultat,
  isPartiValgResultat,
  isParti,
  ValgResultat,
  PartiValgResultat,
  PageType,
  FetchError,
  Geografi,
  Parti
} from '../domain'

export function isValidResult(
  resultat: ValgResultat | PartiValgResultat,
  currentPage: PageType,
  valgtype: 'fy' | 'ko'
) {
  // På partisider for partier som bare stiller til fylkesvalg eller bare stiller til kommunevalg
  // viser vi resultatet i fylket eller kommunen de stilte i. Denne logikken bør kanskje være mer sentralisert og robust.
  if (isParti(currentPage)) {
    const valgData = currentPage.valg.find(v => v.valgKey === '2019/' + valgtype)
    if (
      !!valgData &&
      valgData.antallValgdistrikter === 1 &&
      isValgResultat(resultat) &&
      currentPage.valg[0].geografiKey === resultat.geografi.key
    ) {
      return true
    }
  }

  const isSameGeografi =
    isGeografi(currentPage) && isValgResultat(resultat) && currentPage.key === resultat.geografi.key
  const isSameParti =
    isParti(currentPage) && isPartiValgResultat(resultat) && currentPage.id === resultat.parti.id

  return isSameGeografi || isSameParti
}

export function isValidError(fetchError: FetchError, currentPage: PageType, valgtype: 'fy' | 'ko') {
  // På partisider for partier som bare stiller til fylkesvalg eller bare stiller til kommunevalg
  // viser vi resultatet i fylket eller kommunen de stilte i. Denne logikken bør kanskje være mer sentralisert og robust.
  if (isParti(currentPage)) {
    const valgData = currentPage.valg.find(v => v.valgKey === '2019/' + valgtype)
    if (
      !!valgData &&
      valgData.antallValgdistrikter === 1 &&
      isGeografi(fetchError.grunndata) &&
      currentPage.valg[0].geografiKey === fetchError.grunndata.key
    ) {
      return true
    }
  }

  const isSameGeografi =
    isGeografi(fetchError.grunndata) &&
    isGeografi(currentPage) &&
    fetchError.grunndata.key === currentPage.key

  const isSameParti =
    isParti(fetchError.grunndata) &&
    isParti(currentPage) &&
    fetchError.grunndata.id === currentPage.id

  return isSameGeografi || isSameParti
}
